/*@flow*/
import * as I from 'immutable';
import getCompanyId from './getCompanyId';

export default function useCompanyId(): any {
  return getCompanyId();
}
